import React, { useEffect } from "react";
import VerificationLayout from "../../layout/VerificationLayout.component";
import { Box, Typography } from "@mui/material";
import ecCongrats from "../../../assets/images/delivery.png";
import AppButton from "../../base/AppButton.component";
import { useMutation } from "@apollo/client";
import { EMAIL_OPT_OUT } from "../../../graphql/mutation/mutation";
import { useParams } from "react-router-dom";

const UnSubscribeComponent = () => {
  const params = useParams();
  console.log("paramss", params);

  const [optOut, { loading: requestLoading }, refetch] =
    useMutation(EMAIL_OPT_OUT);

  useEffect(() => {
    console.log("call query");
    optOut({
      variables: {
        optOutInput: {
          user_id: params?.userId,
          isOptout: true,
        },
      },
    });
  }, [params?.userId]);

  return (
    <VerificationLayout>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          height: "89%",
        }}
      >
        <img src={ecCongrats} width={120} alt="logo" />

        <Typography variant="h5" fontWeight="bold" paddingTop="35px">
          You have successfully unsubscribed
        </Typography>
        <Typography variant="h7" paddingBottom="35px">
          Your request to stop receiving our mail has been successfully
          processed
        </Typography>

        <AppButton
          buttonText="re-subscribe"
          clickHandler={() => {
            optOut({
              variables: {
                optOutInput: {
                  user_id: params?.userId,
                  isOptout: false,
                },
              },
            });
          }}
        ></AppButton>
      </Box>
    </VerificationLayout>
  );
};

export default UnSubscribeComponent;